<!--suppress ALL -->
<template>
    <component :is="type" :href="to" :to="to" :target="targetBlank ? '_blank' : '_self'"
    :data-tooltip="tooltipText ? tooltipText : false" :class="tooltipText ? 'tooltip' : ''">
        <slot></slot>
    </component>
</template>

<script lang="ts">
	import {Component, Vue, Prop} from "annotation";

	@Component
	export default class GLink extends Vue {

		@Prop({default: '/'})
		public to: string;

		@Prop({default: '', type: String})
		public tooltipText: string;

		@Prop({default: false, type: Boolean})
		public targetBlank: boolean;

		public get hasVueRouter() {
			return this.$router !== undefined && this.$router !== undefined && this.to;
		}

		public get type() {
			return this.hasVueRouter ? 'router-link' : 'a';
		}
	}
</script>
